import { Component, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-notes-de-version',
    templateUrl: './notes-de-version.component.html',
    styleUrls: ['./notes-de-version.component.scss'],
    imports: [TranslateModule, MatIcon, MatProgressSpinnerModule]
})
export class NotesDeVersionComponent implements OnInit {    
  readonly appVersion = environment.app.version;
  readonly appVersionCourte = environment.app.version.split('.').slice(0, 2).join('.');
  readonly appBuild = environment.app.build;
  contenuHtml: SafeHtml = '';
  chargement = true;
  erreur = false;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.chargerNotesVersion();
  }

  chargerNotesVersion(): void {
    this.http.get('assets/data/release-notes.md', { responseType: 'text' }).subscribe({
      next: (markdown) => {
        const markdownAvecVersion = markdown.replace('{{APP_VERSION}}', this.appVersion);
        const html = marked(markdownAvecVersion) as string;
        this.contenuHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        this.chargement = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des notes de version:', error);
        this.erreur = true;
        this.chargement = false;
      }
    });
  }
}
